import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { ForbiddenComponent } from './fms-app/forbidden/forbidden.component';

const routes: Routes = [{
  path: '',
  component: AppComponent,
  children: [{
    path : '',
    loadChildren: () => import('./fms-auth/fms-auth.module').then(m => m.FmsAuthModule)
  },
  // { path: 'forbidden', component: ForbiddenComponent },
]
}]
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
